import { AuthenticationResponseCode, LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import { GetMessageExceptionCode } from "@/helper/shareHelper";
import { MerchantId, ValidateTemplateModel } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import {
  ConvertToMerchantAddressList,
  ConvertToMerchantDetail,
  CoventToConnectPeakWithMerchantIdModel,
} from "@/service/merchant/merchantFacade";
import { ConvertToUserTemplateModel } from "@/service/user/userFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";
import textHelper from "../../helper/textHelper";

@Module({ namespaced: true })
export default class Setting extends VuexModule {
  private merchantDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private connectPeakWithMerchantIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private settingConnectPeakModel: any = null;
  private updateConnectPeakWithMerchantIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantDetail: any = null;
  private merchantRevenueDepartmentContactLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantRevenueDepartmentContact = 0;
  private updateMerchantRevenueDepartmentContactLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantAddressListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantAddressList: Array<any> = [];
  private updateMerchantDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  // private userDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  // private userDetail: any | null = null;
  private updateMerchantLogoAndStampLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private refreshVerificationLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private updateUserProfileLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private changePasswordLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private passwordCurrent = false;
  private invalidPinCode = false;

  get getMerchantDetailLoadingStatus(): LoadingStatusType {
    return this.merchantDetailLoadingStatus;
  }

  get getInvalidPinCode(): boolean {
    return this.invalidPinCode;
  }

  get getConnectPeakWithMerchantIdLoadingStatus(): LoadingStatusType {
    return this.connectPeakWithMerchantIdLoadingStatus;
  }

  get getMerchantDetail(): any {
    return this.merchantDetail;
  }

  get getSettingConnectPeakModel(): any {
    return this.settingConnectPeakModel;
  }

  get getUpdateConnectPeakWithMerchantIdLoadingStatus(): LoadingStatusType {
    return this.updateConnectPeakWithMerchantIdLoadingStatus;
  }

  get getMerchantRevenueDepartmentContactLoadingStatus(): LoadingStatusType {
    return this.merchantRevenueDepartmentContactLoadingStatus;
  }

  get getMerchantRevenueDepartmentContact(): any {
    return this.merchantRevenueDepartmentContact;
  }

  get getUpdateMerchantRevenueDepartmentContactLoadingStatus(): LoadingStatusType {
    return this.updateMerchantRevenueDepartmentContactLoadingStatus;
  }

  get getMerchantAddressListLoadingStatus(): LoadingStatusType {
    return this.merchantAddressListLoadingStatus;
  }

  get getMerchantAddressList(): Array<any> {
    return this.merchantAddressList;
  }

  get getUpdateMerchantDetailLoadingStatus(): LoadingStatusType {
    return this.updateMerchantDetailLoadingStatus;
  }

  get getUpdateMerchantLogoAndStampLoadingStatus(): LoadingStatusType {
    return this.updateMerchantLogoAndStampLoadingStatus;
  }

  get getRefreshVerificationLoadingStatus(): LoadingStatusType {
    return this.refreshVerificationLoadingStatus;
  }

  get getUpdateUserProfileLoadingStatus(): LoadingStatusType {
    return this.updateUserProfileLoadingStatus;
  }

  get getChangePasswordLoadingStatus(): LoadingStatusType {
    return this.changePasswordLoadingStatus;
  }

  get getPasswordCurrent(): boolean {
    return this.passwordCurrent;
  }

  @Mutation
  public MutationMerchantRevenueDepartmentContactLoadingStatus(status: LoadingStatusType) {
    this.merchantRevenueDepartmentContactLoadingStatus = status;
  }

  @Mutation
  public MutationMerchantRevenueDepartmentContact(merchantRevenueDepartmentContact: number) {
    this.merchantRevenueDepartmentContact = merchantRevenueDepartmentContact;
  }
  @Mutation
  public MutationMerchantDetailLoadingStatus(status: LoadingStatusType) {
    this.merchantDetailLoadingStatus = status;
  }
  @Mutation
  public MutationConnectPeakWithMerchantIdLoadingStatus(status: LoadingStatusType) {
    this.connectPeakWithMerchantIdLoadingStatus = status;
  }

  @Mutation
  public MutationSetInvalidPinCode(invalidPinCode: boolean) {
    this.invalidPinCode = invalidPinCode;
  }

  @Mutation
  public MutationMerchantDetail(merchantDetail: any) {
    this.merchantDetail = merchantDetail;
  }

  @Mutation
  public MutationSettingConnectPeakModel(settingConnectPeakModel: any) {
    this.settingConnectPeakModel = settingConnectPeakModel;
  }

  @Mutation
  public SetUpdateConnectPeakWithMerchantIdLoadingStatus(status: LoadingStatusType) {
    this.updateConnectPeakWithMerchantIdLoadingStatus = status;
  }

  @Mutation
  public MutationUpdateMerchantRevenueDepartmentContactLoadingStatus(status: LoadingStatusType) {
    this.updateMerchantRevenueDepartmentContactLoadingStatus = status;
  }

  @Mutation
  public SetMerchantAddressListLoadingStatus(status: LoadingStatusType) {
    this.merchantAddressListLoadingStatus = status;
  }

  @Mutation
  public SetMerchantAddressList(merchantAddressList: Array<any>) {
    this.merchantAddressList = merchantAddressList;
  }

  @Mutation
  public SetUpdateMerchantDetailLoadingStatus(status: LoadingStatusType) {
    this.updateMerchantDetailLoadingStatus = status;
  }

  @Mutation
  public SetUpdateMerchantLogoAndStampLoadingStatus(status: LoadingStatusType) {
    this.updateMerchantLogoAndStampLoadingStatus = status;
  }

  @Mutation
  public SetRefreshVerificationStatusLoadingStatus(status: LoadingStatusType) {
    this.refreshVerificationLoadingStatus = status;
  }

  @Mutation
  public SetUpdateUserProfileLoadingStatus(status: LoadingStatusType) {
    this.updateUserProfileLoadingStatus = status;
  }

  @Mutation
  public SetChangePasswordLoadingStatus(status: LoadingStatusType) {
    this.changePasswordLoadingStatus = status;
  }

  @Mutation
  public SetPasswordCurrent(passwordCurrent: boolean) {
    this.passwordCurrent = passwordCurrent;
  }

  @Action DoGetMerchantDetail() {
    if (this.merchantDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.GetMerchantDetail().then((resMerchantDetail: any) => {
        if (resMerchantDetail.status.IsSuccess()) {
          const detail = ConvertToMerchantDetail(resMerchantDetail.data.detail);
          this.context.commit("MutationMerchantDetail", detail);
        }
        this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action DoGetMerchantRevenueDepartmentContact() {
    if (this.merchantRevenueDepartmentContactLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationMerchantRevenueDepartmentContactLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.GetMerchantRevenueDepartmentContact().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactId = res.data.data.revenueDepartmentContactId;
          this.context.commit("MutationMerchantRevenueDepartmentContact", contactId);
        }
        this.context.commit("MutationMerchantRevenueDepartmentContactLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action DoUpdateMerchantRevenueDepartmentContact(id: number) {
    if (this.merchantRevenueDepartmentContactLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationUpdateMerchantRevenueDepartmentContactLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.UpdateMerchantRevenueDepartmentContact(id).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          store.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Edited_Connect_PEAK_Success"),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
          this.context.commit("MutationMerchantRevenueDepartmentContactLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          store.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationUpdateMerchantRevenueDepartmentContactLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  DoGetMerchantAddressList() {
    if (this.merchantAddressListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetMerchantAddressListLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.MerchantService.DoGetMerchantAddressList().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const merchantAddressList = ConvertToMerchantAddressList(res.data.addressList);
          this.context.commit("SetMerchantAddressList", merchantAddressList);
        }
        this.context.commit("SetMerchantAddressListLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  DoUpdateMerchantDetail(input: any) {
    if (this.updateMerchantDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetInvalidPinCode", false);
      this.context.commit("SetUpdateMerchantDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.MerchantService.DoUpdateMerchantDetail(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Edited_Setting_Success", { name: i18n.t("Menu_Organization") }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          window.location.href = `${
            window.location.origin
          }/setting/settingMerchant?emi=${MerchantId().PeakEncryption()}`;
          this.context.commit("SetUpdateMerchantDetailLoadingStatus", LoadingStatusType.Success);
          this.context.commit("SetMerchantAddressListLoadingStatus", LoadingStatusType.None);
          this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.None);
        } else {
          this.context.commit("SetUpdateMerchantDetailLoadingStatus", LoadingStatusType.Fail);
          if (res.data.exception.code === AuthenticationResponseCode.InvalidPINCode) {
            this.context.commit("MutationSetInvalidPinCode", true);
          }
        }

        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  DoUpdateMerchantLogoAndStamp(updateMerchantLogoAndStamp: any) {
    if (this.updateMerchantLogoAndStampLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateMerchantLogoAndStampLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoUpdateMerchantLogoAndStamp(updateMerchantLogoAndStamp).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Edited_Setting_Success", { name: i18n.t("Logo_And_Stamp") }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          window.location.href = `${
            window.location.origin
          }/setting/settingLogoStamp?emi=${MerchantId().PeakEncryption()}`;
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateMerchantLogoAndStampLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  DoRefreshVerifiedStatus() {
    if (this.refreshVerificationLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetRefreshVerificationStatusLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoRefreshVerifiedStatus().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetRefreshVerificationStatusLoadingStatus", LoadingStatusType.Success);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.commit("SetRefreshVerificationStatusLoadingStatus", LoadingStatusType.Fail);
        }
      });
    }
  }

  @Action
  public DoUpdateUserProfile(input: any) {
    const isValidated = ValidateTemplateModel(input.data);
    if (isValidated) {
      if (this.updateUserProfileLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationSetInvalidPinCode", false);
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("SetUpdateUserProfileLoadingStatus", LoadingStatusType.Loading);
        const userTemplateModel = ConvertToUserTemplateModel(input.data);
        API.UserService.DoUpdateUserProfile({ data: userTemplateModel, pinToken: input.pinToken }).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Edited_Setting_Success", { name: i18n.t("User_Information") }),
                typeMessage: TypeComponentNoti.success,
              },
              { root: true }
            );
            this.context.commit("SetUpdateUserProfileLoadingStatus", LoadingStatusType.Success);
          } else {
            if (res.data.exception.code === AuthenticationResponseCode.InvalidPINCode) {
              this.context.commit("MutationSetInvalidPinCode", true);
            }
            this.context.commit("SetUpdateUserProfileLoadingStatus", LoadingStatusType.Fail);
          }
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("All_Validation"),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
    }
  }

  @Action
  public DoChangePassword(input: any) {
    if (this.changePasswordLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetChangePasswordLoadingStatus", LoadingStatusType.Loading);
      input.password = textHelper.CreateToken(input.password);
      input.newPassword = textHelper.CreateToken(input.newPassword);
      API.UserService.DoChangePassword(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPasswordCurrent", res.data.passwordCurrent);
          if (!res.data.passwordCurrent) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Current_Password_Invalid_Please_Try_Again"),
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetChangePasswordLoadingStatus", LoadingStatusType.Success);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
      });
    }
  }
  @Action DoGetConnectPeakWithMerchantId() {
    if (this.connectPeakWithMerchantIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationConnectPeakWithMerchantIdLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetConnectPeakWithMerchantId().then((res: any) => {
        if (res.status.IsSuccess()) {
          const settingConnectPeakModel = CoventToConnectPeakWithMerchantIdModel(res.data.data);
          this.context.commit("MutationSettingConnectPeakModel", settingConnectPeakModel);
        }
        this.context.commit("MutationConnectPeakWithMerchantIdLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  DoUpdateConnectPeakWithMerchantId(input: any) {
    if (this.updateConnectPeakWithMerchantIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetUpdateConnectPeakWithMerchantIdLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoUpdateConnectPeakWithMerchantId(input).then((res: any) => {
        let alertMessage: any = "";
        let typeMessage = TypeComponentNoti.success;
        if (res.status.IsSuccess()) {
          alertMessage = i18n.t("Successful_PEAK_Connection");
          typeMessage = TypeComponentNoti.success;
        } else {
          alertMessage = GetMessageExceptionCode(res.data.exception);
          typeMessage = TypeComponentNoti.error;
        }
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          },
          { root: true }
        );
        this.context.commit("SetUpdateConnectPeakWithMerchantIdLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
}
